<script setup lang="tsx">
import { ref, watchEffect } from "vue";
import { mapState } from "../../context/context";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {}
);

const mappedState = mapState(["color.fontReverse"]);

const color = ref();

watchEffect(() => {
  color.value = props.color || mappedState["color.fontReverse"].value;
});
</script>

<template>
  <!-- 不设置 width="48" height="48" 自适应父元素 -->
  <!-- viewBox : x y width height , 可重设 viewBox 切除四周多余空白 -->
  <svg
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="none"
    fill="none"
    :style="{
      display: 'block',
      transformOrigin: 'center'
    }"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24 4C12.9587 4 4 12.9587 4 24C4 35.0413 12.9587 44 24 44C35.0413 44 44 35.0413 44 24C44 12.9587 35.0413 4 24 4ZM2 24C2 11.8542 11.8542 2 24 2C36.1458 2 46 11.8542 46 24C46 36.1458 36.1458 46 24 46C11.8542 46 2 36.1458 2 24Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.715 16.285C31.335 15.905 30.7211 15.905 30.3313 16.285L24 22.6163L17.6687 16.285C17.2887 15.905 16.6748 15.905 16.285 16.285C15.905 16.665 15.905 17.2789 16.285 17.6687L22.6163 24L16.285 30.3313C15.905 30.7113 15.905 31.3252 16.285 31.715C16.665 32.095 17.2789 32.095 17.6687 31.715L24 25.3837L30.3313 31.715C30.7113 32.095 31.3252 32.095 31.715 31.715C32.095 31.335 32.095 30.7211 31.715 30.3313L25.3837 24L31.715 17.6687C32.095 17.2887 32.095 16.665 31.715 16.285Z"
      :fill="color"
    />
  </svg>
</template>
